import { render } from "./TocComponent.vue?vue&type=template&id=0a5933c6"
import script from "./TocComponent.vue?vue&type=script&lang=js"
export * from "./TocComponent.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__